import { BrowserRouter, Route } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext';
import { AdminContextProvider } from './context/AdminContext';

import { Dealer } from './pages/Dealer';
import { Home } from "./pages/Home";
import { AuthPage } from './pages/AuthPage';
import { AdminPage } from './pages/AdminPage';
import { AdminLogin } from './pages/AdminLogin';

function App() {

  return (
    <BrowserRouter>
      <AuthContextProvider>
        <Route path="/" exact component={AuthPage} />
        <Route path="/home" exact component={Home} />
        <Route path="/dealer/:id" exact component={Dealer} />
      </AuthContextProvider>

      <AdminContextProvider>
        <Route path="/adminlogin" component={AdminLogin} />
        <Route path="/adminpage" exact component={AdminPage} />
      </AdminContextProvider>
    </BrowserRouter>
  );
}

export default App;
